import React from 'react';
import { Row, Col, Form } from 'reactstrap';
import FormInput from '../../common/FormInput';
import AssociateLocationModal from '../../modals/AssociateLocationModal';
import { useState } from 'react';
import { Location } from 'features/common/location';
import { useFormSection } from 'features/products/context/ProductDetailContext';

const AuditProfile: React.FC = () => {
  const { watch, setValue, getError } = useFormSection('auditProfile');
  const [isLocationModalOpen, setLocationModalOpen] = useState(false);

  const handleSelectLocation = (location: Location | Location[]) => {
    // Handle both single location and array of locations (take first one for single select mode)
    const selectedLocation = Array.isArray(location) ? location[0] : location;
    setValue('ownerLocName', selectedLocation.name);
    setValue('ownerLocId', selectedLocation.rowId);
    setLocationModalOpen(false);
  };

  return (
    <fieldset className="border p-2 ">
      <legend className="float-none w-auto px-2 mb-0 text-body" style={{ fontSize: '0.9rem' }}>Audit Profile</legend>
      <Form>
        <Row>
          <Col md={6}>
            <FormInput
              id="created"
              label="Created"
              value={watch('created') || ''}
              readOnly
            />
            {/* Display validation error if any */}
            {getError('created') && (
              <div className="text-danger small mt-1">
                {getError('created')?.message}
              </div>
            )}
          </Col>
          <Col md={6}>
            <FormInput
              id="createdBy"
              label="Created By"
              value={watch('createdName') || ''}
              readOnly
            />
            {/* Display validation error if any */}
            {getError('createdName') && (
              <div className="text-danger small mt-1">
                {getError('createdName')?.message}
              </div>
            )}
          </Col>
          <Col md={6}>
            <FormInput
              id="lastUpdated"
              label="Last Updated"
              value={watch('updated') || ''}
              readOnly
            />
            {/* Display validation error if any */}
            {getError('updated') && (
              <div className="text-danger small mt-1">
                {getError('updated')?.message}
              </div>
            )}
          </Col>
          <Col md={6}>
            <FormInput
              id="lastUpdatedBy"
              label="Last Updated By"
              value={watch('updatedName') || ''}
              readOnly
            />
            {/* Display validation error if any */}
            {getError('updatedName') && (
              <div className="text-danger small mt-1">
                {getError('updatedName')?.message}
              </div>
            )}
          </Col>
          <Col md={6}>
            <FormInput
              id="locationOwner"
              label="Location Owner"
              value={watch('ownerLocName') || ''}
              onChange={(value: string) => setValue('ownerLocName', value)}
              hasSearchButton
              onSearchClick={() => setLocationModalOpen(true)}
            />
            {/* Display validation error if any */}
            {getError('ownerLocName') && (
              <div className="text-danger small mt-1">
                {getError('ownerLocName')?.message}
              </div>
            )}
          </Col>
        </Row>
      </Form>
      <AssociateLocationModal
        isOpen={isLocationModalOpen}
        onClose={() => setLocationModalOpen(false)}
        onSelect={handleSelectLocation}
      />
    </fieldset>
  );
};

export default AuditProfile; 